module.exports = __webpack_public_path__ + "static/media/paid-search-illustr-3.1858b809.png";